import { useMonthlyAddOns } from '../../settings/tabs/addOns/useMonthlyAddOns';

/**
 * The add-ons read and write of the limit upsell card: `billing.monthlyAddOns` and
 * `billing.setMonthlyAddOns`. A hook of its own, so screen tests can mock it in one place
 * (`jest.setuptests.ts`) and leave the Settings add-ons hook alone.
 */
export function useLimitUpsellAddOns(): ReturnType<typeof useMonthlyAddOns> {
  return useMonthlyAddOns();
}
